
import {of as observableOf,  Observable } from 'rxjs';

import {switchMap, withLatestFrom, filter} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ADMIN_ROLE } from '@careapp/core';
import { Store } from '@ngrx/store';

import * as actions from '../../store/actions/index';
import { getAuthenticationState } from '../../store/reducers/index';
import { isAppReady } from '../../store/reducers/index';

@Injectable()
export class GlobalAdminGuard implements CanActivate {
  private authenticated: Observable<any>;
  private refreshed: Observable<boolean>;
  constructor(private store: Store<any>) {
    this.authenticated = this.store.select(getAuthenticationState);
    this.refreshed = this.store.select(isAppReady);
  }
  public canActivate(): Observable<boolean> {
    return this.refreshed.pipe(
      filter(refreshed => refreshed === true),
      withLatestFrom(this.authenticated),
      switchMap(([refreshed, auth]) => {
        if (
          auth.auth &&
          auth.auth.id &&
          auth.roles &&
          auth.roles.find((role: string) => role === ADMIN_ROLE)
        ) {
          return observableOf(true);
        }
        this.store.dispatch(actions.NavigateAction({ path: ['/auth'] }));
        return observableOf(false);
      }),);
  }
}
